/** The existing two-stroke brand geometry inherits the surrounding text color. */
export function BrandSymbol() {
  return <svg className="brand-symbol" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">
    <g stroke="currentColor" strokeWidth="4" strokeLinecap="round">
      <path d="M8 4 L9 20" />
      <path d="M17 10 L16 20" />
    </g>
  </svg>;
}
